/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInvitationListItemDto } from '../../models/amoxcalli-invitation-list-item-dto';

export interface ApiInvitationsByInstitutionInstitutionIdGet$Json$Params {
  institutionId: string;
}

export function apiInvitationsByInstitutionInstitutionIdGet$Json(http: HttpClient, rootUrl: string, params: ApiInvitationsByInstitutionInstitutionIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliInvitationListItemDto>>> {
  const rb = new RequestBuilder(rootUrl, apiInvitationsByInstitutionInstitutionIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliInvitationListItemDto>>;
    })
  );
}

apiInvitationsByInstitutionInstitutionIdGet$Json.PATH = '/api/invitations/by-institution/{institutionId}';
